// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"base-module--wrapper--2B1Vl","container":"base-module--container--1x1jf","footer":"base-module--footer--1CsgW"};